"use client";

import { FormLabel } from "@frontend/shared/components/ui/form";
import { cn } from "@frontend/shared/lib/utils";
import type { LabelFieldProps } from "../../[clientSlug]/types";

interface LabelComponentProps {
  style: string;
  props: LabelFieldProps;
}

export function LabelComponent({ style, props }: LabelComponentProps) {
  const { labelId, text, htmlFor } = props;

  return (
    <div className={cn(style)}>
      <FormLabel id={labelId} htmlFor={htmlFor} className="text-md font-normal">
        {text}
      </FormLabel>
    </div>
  );
}
